import {GEButton} from '../../../../../common/buttons'
import {FC, useState} from 'react'
import {Tooltip} from 'antd'
import * as API_WORDLIST from '../../../../../shared/http/word-list'
import {fetchWords} from '../../../../../store/words/extraReducers'
import {useAppDispatch} from '../../../../../store/hooks'
import {TbLetterCase, TbQuestionMark} from "react-icons/tb";
import {CiCircleQuestion} from "react-icons/ci";
import InfoWordsDictionaryDialog from "../../../../modalwindows/InfoWordsDictionaryDialog";
import {BsQuestionCircle} from "react-icons/bs";

interface HowCreateCardsProps {
}

const HowCreateCards: FC<HowCreateCardsProps> = ({}) => {
    const [showAddWordInfo, setShowAddWordInfo] = useState<boolean>(false)

    const openAddWordInfo = () => {
        setShowAddWordInfo(true)
    }

    const closeAddWordInfo = () => {
        setShowAddWordInfo(false)
    }

    return (
        <>
            <Tooltip placement='topLeft' title='Как создавать карточки'>
                <GEButton style={{width:32}} onClick={openAddWordInfo} icon={<BsQuestionCircle/>}/>
            </Tooltip>
            <InfoWordsDictionaryDialog cancelWindow={closeAddWordInfo} open={showAddWordInfo}/>
        </>
    )
}

export default HowCreateCards